import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Nav from 'react-bootstrap/Nav';
import { useNavigate, Link } from 'react-router-dom';
import { Navbar, Container, Button, Card } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import './profile.css'; // Assuming this has any specific overrides

const Profile = () => {
  const navigate = useNavigate();

  // States mapped from registration
  const [phoneNumber, setPhoneNumber] = useState('');
  const [altPhone, setAtlPhone] = useState('');
  const [name, setName] = useState('');
  const [mName, setmName] = useState('');
  const [lName, setlName] = useState('');
  const [fName, setfName] = useState('');
  const [dob, setDob] = useState('');
  const [fullAddress, setfullAddress] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [district, setDistrict] = useState('');
  const [state, setState] = useState('Ladakh');
  const [petCenter, setPetCenter] = useState('');
  const [writtenCenter, setWrittenCenter] = useState('');
  const [gender, setGender] = useState('');
  const [category, setCategory] = useState('');
  const [specialCategory, setSpecialCategory] = useState('None');
  const [esm, setEsm] = useState("noEsm");
  const [esmYears, setEsmYears] = useState("");
  const [esmMonths, setEsmMonths] = useState("");
  const [esmDays, setEsmDays] = useState("");
  const [qualification, setQualification] = useState('10th Pass');
  const [bonus, setBonus] = useState('noAQT');
  const [email, setEmail] = useState('');
  const [criminal, setCriminal] = useState("No");
  const [criminalDetails, setCriminalDetails] = useState("");

  // Files
  const [profile, setProfile] = useState(null); // Local photo preview
  const [photoFile, setPhotoFile] = useState(null);
  const [dobFile, setDobFile] = useState(null);
  const [domFile, setDomFile] = useState(null);
  const [educationFile, setEducationFile] = useState(null);
  const [stFile, setStFile] = useState(null);
  const [specialCategoryFile, setSpecialCategoryFile] = useState(null);
  const [bonusFile, setBonusFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signature, setSignature] = useState(null); // Local signature preview

  // File Preview URLs from Server
  const [photoURL, setPhotoURL] = useState("");
  const [dobURL, setdobURL] = useState("");
  const [domURL, setdomURL] = useState("");
  const [eduURL, seteduURL] = useState("");
  const [stURL, setstURL] = useState("");
  const [specialCategoryURL, setSpecialCategoryURL] = useState("");
  const [bonusURL, setbonusURL] = useState("");
  const [esmURL, setesmURL] = useState("");
  const [signatureURL, setsignatureURL] = useState("");

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const handlephotoFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const fileSize = event.target.files[0].size;
      if (fileSize > 524288) {
        toast.error("Selected file size is " + formatFileSize(fileSize) + ". Please choose a file less than 512 KB");
        event.target.value = "";
        setPhotoFile(null);
      } else {
        setProfile(URL.createObjectURL(event.target.files[0]));
        setPhotoFile(event.target.files[0]);
      }
    }
  };

  const handleeducationFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setEducationFile(null);
      } else {
        setEducationFile(event.target.files[0]);
      }
    }
  };

  const handledobfilechange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setDobFile(null);
      } else {
        setDobFile(event.target.files[0]);
      }
    }
  };

  const handledomfilechange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setDomFile(null);
      } else {
        setDomFile(event.target.files[0]);
      }
    }
  };

  const handleSpecialCategoryFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setSpecialCategoryFile(null);
      } else {
        setSpecialCategoryFile(event.target.files[0]);
      }
    }
  };

  const handlesignaturefilechange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setSignatureFile(null);
      } else {
        setSignature(URL.createObjectURL(event.target.files[0]));
        setSignatureFile(event.target.files[0]);
      }
    }
  };

  const handleSTfilechange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setStFile(null);
      } else {
        setStFile(event.target.files[0]);
      }
    }
  };

  const handleBonusfilechange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 524288) {
        toast.error("Please choose a file less than 512kb");
        event.target.value = "";
        setBonusFile(null);
      } else {
        setBonusFile(event.target.files[0]);
      }
    }
  };

  const uploadFileToS3 = async (presignedPostData, file) => {
    try {
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach(key => {
        formData.append(key, presignedPostData.fields[key]);
      });
      formData.append("file", file);
      await fetch(presignedPostData.url, { method: 'POST', body: formData });
    } catch (error) {
      throw error;
    }
  };

  const handleExit = () => {
    navigate("/home");
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      // upload to S3
      const { data: presignedPostData } = await axios.get('/api/getUrls');
      if (photoFile) await uploadFileToS3(presignedPostData.photo, photoFile);
      if (dobFile) await uploadFileToS3(presignedPostData.dob, dobFile);
      if (domFile) await uploadFileToS3(presignedPostData.dom, domFile);
      if (educationFile) await uploadFileToS3(presignedPostData.education, educationFile);
      if (stFile) await uploadFileToS3(presignedPostData.st, stFile);
      if (specialCategoryFile) await uploadFileToS3(presignedPostData.specialCategory, specialCategoryFile);
      if (bonus === "LMV" && bonusFile) await uploadFileToS3(presignedPostData.bonus, bonusFile);
      if (signatureFile) await uploadFileToS3(presignedPostData.signature, signatureFile);

      // make update request to backend
      const response = await axios.post('/api/updateDetails', {
        phone: phoneNumber,
        altPhone: altPhone,
        Name: name,
        mName: mName,
        lName: lName,
        fName: fName,
        fullAddress: fullAddress,
        city: city,
        zipcode: zipcode,
        state: state,
        district: district,
        petCenter: petCenter,
        writtenCenter: writtenCenter,
        gender: gender,
        qualification: qualification,
        category: category,
        specialCategory: specialCategory,
        bonus: bonus,
        esm: esm,
        esmYears: esmYears,
        esmMonths: esmMonths,
        esmDays: esmDays,
        email: email,
        criminal: criminal,
        criminalDetails: criminalDetails
      });

      if (response.data === "Success") {
        toast.success("Changes Saved!");
      }
    } catch (error) {
      console.log("error");
      toast.error("Failed to update profile.");
    }

    //console.log("NO UPDATING NOW.....")
  };

  useEffect(() => {
    axios.get("/api/getFiles").then(response => {
      setPhotoURL(response.data.photoURL || "");
      setdobURL(response.data.dobURL || "");
      setdomURL(response.data.domURL || "");
      seteduURL(response.data.eduURL || "");
      setstURL(response.data.stURL || "");
      setSpecialCategoryURL(response.data.specialCategoryURL || response.data.esmURL || "");
      setbonusURL(response.data.bonusURL || "");
      setesmURL(response.data.esmURL || "");
      setsignatureURL(response.data.signURL || "");
    });

    axios.get('/api/getDetails')
      .then(response => {
        if (response.data) {
          if (response.data.message) {
            toast.error(response.data.message);
          } else {
            setName(response.data.Name || '');
            setmName(response.data.mName || '');
            setlName(response.data.lName || '');
            setPhoneNumber(response.data.Phone || '');
            setAtlPhone(response.data.altPhone || '');
            setfName(response.data.fName || '');
            setDob(response.data.dob || '');
            setfullAddress(response.data.fullAddress || '');
            setDistrict(response.data.district || '');
            setCity(response.data.city || '');
            setZipcode(response.data.zipcode || '');
            setState(response.data.state || 'Ladakh');
            setPetCenter(response.data.petCenter || '');
            setWrittenCenter(response.data.writtenCenter || '');
            setGender(response.data.gender || '');
            const savedQualification = response.data.qualification === '10th Class/Matriculation'
              ? '10th Pass'
              : response.data.qualification;
            setQualification(['10th Pass', '10+2 with Chemistry and Physics'].includes(savedQualification) ? savedQualification : '');
            setCategory(response.data.category || '');
            const savedSpecialCategory = response.data.specialCategory || (response.data.esm === 'esm' ? 'Ex-Servicemen' : 'None');
            setSpecialCategory(savedSpecialCategory);
            setBonus(response.data.bonus === 'LMV' ? 'LMV' : 'noAQT');
            setEsm(savedSpecialCategory === 'Ex-Servicemen' ? 'esm' : 'noEsm');
            // FIX: Explicitly check for null/undefined so that integer 0 is preserved.
            setEsmYears(response.data.esm_years != null ? String(response.data.esm_years) : (response.data.esmYears != null ? String(response.data.esmYears) : ''));
            setEsmMonths(response.data.esm_months != null ? String(response.data.esm_months) : (response.data.esmMonths != null ? String(response.data.esmMonths) : ''));
            setEsmDays(response.data.esm_days != null ? String(response.data.esm_days) : (response.data.esmDays != null ? String(response.data.esmDays) : ''));
            setEmail(response.data.email || '');

            setCriminal(response.data.criminal || "No");
            setCriminalDetails(response.data.criminalDetails || "");

            console.log(response.data)
          }
        }
      })
      .catch(error => {
        console.error('Error fetching profile details:', error);
        navigate("/");
      });
  }, [navigate]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', backgroundColor: '#06213f' }}>
        <img
          src="/logo_0.png"
          alt="Header Image"
          style={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '100px',
            objectFit: 'contain',
            backgroundColor: '#06213f',
          }}
        />
      </div>

      <Navbar collapseOnSelect expand="lg" variant="dark" style={{ backgroundColor: '#06213f' }}>
        <Container>
          <Navbar.Brand href="/home">Ladakh Police Constable Recruitment 2026</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
            <Navbar.Text className="text-light fw-medium">
              Signed in as: {phoneNumber}
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="min-vh-100 d-flex justify-content-center py-5" style={{ backgroundColor: '#dee0d7' }}>
        <Card className="shadow-lg border-0 rounded-4" style={{ maxWidth: "1000px", width: '100%', margin: '0 15px' }}>
          <Card.Body className="p-4 p-md-5">

            <form onSubmit={handleUpdate} className="mx-auto">
              <div className="text-center mb-5">
                <h2 className="fw-bold mb-2" style={{ color: '#06213f' }}>Profile Details</h2>
                <p className="text-muted">View your account and application information.</p>
              </div>

              {/* --- SECTION: PHOTO UPLOAD --- */}
              <div className="d-flex flex-column align-items-center mb-5 pb-4 border-bottom">

                {/* Show the preview if either a local file is chosen OR a URL exists */}
                {(profile || photoURL) && (
                  <div className="position-relative mb-3" style={{ width: '150px', height: '180px' }}>
                    <img
                      alt="Profile Preview"
                      src={profile || photoURL}
                      className="img-thumbnail shadow-sm object-fit-cover w-100 h-100"
                    />
                  </div>
                )}

                <div className="text-center w-100" style={{ maxWidth: '300px' }}>
                  <label className="form-label fw-semibold">1. Update Passport Photo</label>
                  <input type="file" className="form-control form-control-sm" accept="image/jpeg" onChange={handlephotoFileChange} />
                  <div className="form-text mt-1">(Max 512kb allowed; jpg/jpeg only)</div>
                </div>
              </div>

              {/* --- SECTION: PERSONAL DETAILS --- */}
              <h5 className="fw-bold text-uppercase mb-4" style={{ color: '#06213f' }}>Personal Details</h5>

              <div className="row g-4 mb-4">
                <div className="col-12">
                  <label className="form-label fw-semibold">2. Full Name</label>
                  <div className="row g-3">
                    <div className="col-12 col-md-4">
                      <input type="text" className="form-control bg-light" id="name" placeholder="First Name" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="col-12 col-md-4">
                      <input type="text" className="form-control bg-light" id="mName" placeholder="Middle Name (Optional)" value={mName} onChange={(e) => setmName(e.target.value)} />
                    </div>
                    <div className="col-12 col-md-4">
                      <input type="text" className="form-control bg-light" id="lName" placeholder="Last Name" value={lName} onChange={(e) => setlName(e.target.value)} />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="fname" className="form-label fw-semibold">3. Father's Name</label>
                  <input type="text" className="form-control bg-light" id="fname" value={fName} onChange={(e) => setfName(e.target.value)} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="dob" className="form-label fw-semibold">4. Date of Birth</label>
                  <input type="date" className="form-control bg-light" id="dob" value={dob} disabled />
                  <div className="form-text mt-1 text-danger">Date of Birth cannot be edited.</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold d-block">5. Sex</label>
                  <select className="form-select bg-light" id="gender" value={gender} onChange={(e) => setGender(e.target.value)} required>
                    <option value="">Select Sex...</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
              </div>

              {/* --- SECTION: CONTACT & ADDRESS --- */}
              <h5 className="fw-bold text-uppercase mb-4 mt-5 border-top pt-4" style={{ color: '#06213f' }}>Contact & Address</h5>

              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <label htmlFor="email" className="form-label fw-semibold">6. Email Address</label>
                  <input type="email" className="form-control bg-light" id="email" value={email} style={{ textTransform: 'uppercase' }} onChange={(e) => setEmail(e.target.value)} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="phoneNumber" className="form-label fw-semibold">7. Mobile Number</label>
                  <input type="tel" className="form-control bg-light" id="phoneNumber" value={phoneNumber} disabled />
                  <div className="form-text mt-1 text-danger">Registered mobile number cannot be edited.</div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="altPhone" className="form-label fw-semibold">8. Alternate Phone (Optional)</label>
                  <input type="tel" className="form-control bg-light" id="altPhone" value={altPhone} onChange={(e) => setAtlPhone(e.target.value.replace(/\D/g, ''))} pattern="[0-9]{10}" maxLength="10" title="Please enter a 10-digit mobile number" />
                </div>

                <div className="col-12">
                  <label htmlFor="fullAddress" className="form-label fw-semibold">9. Permanent Address</label>
                  <input type="text" className="form-control bg-light" id="fullAddress" value={fullAddress} onChange={(e) => setfullAddress(e.target.value)} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="city" className="form-label fw-semibold">10. City/Town/Village</label>
                  <input type="text" className="form-control bg-light" id="city" value={city} onChange={(e) => setCity(e.target.value)} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="zipcode" className="form-label fw-semibold">11. Pincode</label>
                  <input type="text" pattern="[0-9]{6}" title="Six digit zip code" className="form-control bg-light" id="zipcode" value={zipcode} onChange={(e) => setZipcode(e.target.value)} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor="district" className="form-label fw-semibold">12. District</label>
                  <select className="form-select bg-light" id="district" value={district} disabled>
                    <option value="">Select District...</option>
                    <option value="Leh">Leh</option>
                    <option value="Nubra">Nubra</option>
                    <option value="Sham">Sham</option>
                    <option value="Changthang">Changthang</option>
                    <option value="Kargil">Kargil</option>
                    <option value="Zanskar">Zanskar</option>
                    <option value="Drass">Drass</option>
                  </select>
                  <div className="form-text mt-1 text-danger">District cannot be edited.</div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="state" className="form-label fw-semibold">13. State/UT</label>
                  <input type="text" className="form-control bg-light text-muted" id="state" value="Ladakh" readOnly required disabled />
                </div>

              </div>

              {/* --- SECTION: EXAM PREFERENCES --- */}
              <h5 className="fw-bold text-uppercase mb-4 mt-5 border-top pt-4" style={{ color: '#06213f' }}>Exam Preferences</h5>

              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <label htmlFor="petCenter" className="form-label fw-semibold">14. Preferred Center for Physical Test</label>
                  <select className="form-select bg-light" id="petCenter" value={petCenter} onChange={(e) => setPetCenter(e.target.value)} required>
                    <option value="">Select Center...</option>
                    <option value="Leh">Leh</option>
                    <option value="Kargil">Kargil</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label htmlFor="writtenCenter" className="form-label fw-semibold">15. Preferred Center for Written Test</label>
                  <select className="form-select bg-light" id="writtenCenter" value={writtenCenter} onChange={(e) => setWrittenCenter(e.target.value)} required>
                    <option value="">Select Center...</option>
                    <option value="Leh">Leh</option>
                    <option value="Kargil">Kargil</option>
                  </select>
                </div>
              </div>

              {/* --- SECTION: QUALIFICATIONS & ELIGIBILITY --- */}
              <h5 className="fw-bold text-uppercase mb-4 mt-5 border-top pt-4" style={{ color: '#06213f' }}>Qualifications & Eligibility</h5>

              <div className="row g-4 mb-4">
                {/* Category */}
                <div className="col-md-6">
                  <label htmlFor="category" className="form-label fw-semibold">16. Category</label>
                  <select className="form-select bg-light" id="category" value={category} disabled>
                    {!["ST", "EWS"].includes(category) && <option value={category} disabled>{category || 'Loading...'}</option>}
                    <option value="ST">ST</option>
                    <option value="EWS">EWS</option>
                  </select>
                  <div className="form-text mt-1 text-danger">Category cannot be edited.</div>

                  {["ST", "EWS"].includes(category) && (
                    <div className="mt-3 p-3 bg-white border border-primary shadow-sm rounded-3">
                      <label className="form-label fw-semibold">16a. Update Category Certificate <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                      <input type="file" className="form-control mb-2" accept="application/pdf" onChange={handleSTfilechange} />
                      {stURL && <a href={stURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                    </div>
                  )}
                </div>

                {/* Special Category */}
                <div className="col-md-6">
                  <label htmlFor="specialCategory" className="form-label fw-semibold">17. Special Category</label>
                  <select className="form-select bg-light" id="specialCategory" value={specialCategory} disabled>
                    {!["None", "Ex-Agniveer", "Ex-Servicemen"].includes(specialCategory) && <option value={specialCategory} disabled>{specialCategory}</option>}
                    <option value="None">None</option>
                    <option value="Ex-Agniveer">Ex-Agniveer</option>
                    <option value="Ex-Servicemen">Ex-Servicemen</option>
                  </select>
                  <div className="form-text mt-1 text-danger">Special Category cannot be edited.</div>

                  {["Ex-Agniveer", "Ex-Servicemen"].includes(specialCategory) && (
                    <div className="mt-3 p-3 bg-white border border-primary shadow-sm rounded-3">
                      <label className="form-label fw-semibold">17a. Update Special Category Certificate <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                      <input type="file" className="form-control mb-2" accept="application/pdf" onChange={handleSpecialCategoryFileChange} />
                      {(specialCategoryURL || esmURL) && <a href={specialCategoryURL || esmURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                    </div>
                  )}
                </div>

                {/* Conditional ESM Qualifying Service Period */}
                {esm === "esm" && (
                  <div className="col-12">
                    <div className="card p-4 bg-white border border-primary shadow-sm rounded-3">
                      <div className="row g-3">
                        <div className="col-12">
                          <label className="form-label fw-semibold text-dark">
                            17b. Total Qualifying Service Period:
                          </label>
                          <div className="row g-2">
                            <div className="col-4">
                              <div className="form-floating">
                                <select disabled className="form-select bg-light" id="esmYears" value={esmYears}>
                                  <option value="">Select...</option>
                                  {[...Array(46).keys()].map(y => (
                                    <option key={y} value={String(y)}>{y} {y === 1 ? 'Year' : 'Years'}</option>
                                  ))}
                                </select>
                                <label htmlFor="esmYears">Years</label>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="form-floating">
                                <select disabled className="form-select bg-light" id="esmMonths" value={esmMonths}>
                                  <option value="">Select...</option>
                                  {[...Array(12).keys()].map(m => (
                                    <option key={m} value={String(m)}>{m} {m === 1 ? 'Month' : 'Months'}</option>
                                  ))}
                                </select>
                                <label htmlFor="esmMonths">Months</label>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="form-floating">
                                <select disabled className="form-select bg-light" id="esmDays" value={esmDays}>
                                  <option value="">Select...</option>
                                  {[...Array(31).keys()].map(d => (
                                    <option key={d} value={String(d)}>{d} {d === 1 ? 'Day' : 'Days'}</option>
                                  ))}
                                </select>
                                <label htmlFor="esmDays">Days</label>
                              </div>
                            </div>
                          </div>
                          <div className="form-text text-muted mt-2">
                            Service period cannot be edited.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Essential Educational Qualification */}
                <div className="col-md-6">
                  <label htmlFor="qualification" className="form-label fw-semibold">18. Essential Educational Qualification</label>
                  <select className="form-select bg-light" id="qualification" value={qualification} disabled>
                    <option value="" disabled>Select Qualification...</option>
                    <option value="10+2 with Chemistry and Physics">10+2 with Chemistry and Physics</option>
                    <option value="10th Pass">10th Pass</option>
                  </select>
                  <div className="form-text mt-1 text-danger">Essential Educational Qualification cannot be edited.</div>
                </div>

                {/* Desired Qualification */}
                <div className="col-md-6">
                  <label htmlFor="bonus" className="form-label fw-semibold">19. Desired Qualification: Do you have an LMV driving license with transport endorsement?</label>
                  <select className="form-select bg-light" id="bonus" value={bonus} disabled>
                    <option value="noAQT">No</option>
                    <option value="LMV">Yes</option>
                  </select>
                  <div className="form-text mt-1 text-danger">LMV qualification cannot be edited.</div>

                  {bonus === "LMV" && (
                    <div className="mt-3 p-3 bg-white border border-primary shadow-sm rounded-3">
                      <label className="form-label fw-semibold">19a. Update Desired Qualification Certificate <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                      <input type="file" className="form-control mb-2" accept="application/pdf" onChange={handleBonusfilechange} />
                      {bonusURL && <a href={bonusURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                    </div>
                  )}
                </div>

              </div>

              {/* --- SECTION: CRIMINAL CASE DISCLOSURE --- */}
              <div className="col-12 mt-4">
                <label className="form-label fw-semibold d-block">
                  20. Have you ever been involved in any criminal case, whether pending or resulting in conviction?
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="criminalOptions"
                    id="criminalYes"
                    checked={criminal === "Yes"}
                    onChange={() => setCriminal("Yes")}
                  />
                  <label className="form-check-label" htmlFor="criminalYes">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="criminalOptions"
                    id="criminalNo"
                    checked={criminal === "No"}
                    onChange={() => {
                      setCriminal("No");
                      setCriminalDetails(""); // Wipe details clear if flipped back to No
                    }}
                  />
                  <label className="form-check-label" htmlFor="criminalNo">No</label>
                </div>
              </div>

              {/* Conditional Criminal Case Details Textarea */}
              {criminal === "Yes" && (
                <div className="col-12 mt-3">
                  <div className="card p-4 bg-white border border-danger shadow-sm rounded-3">
                    <label htmlFor="criminalDetails" className="form-label fw-semibold text-danger">
                      20a. Details of Criminal Case(s):
                    </label>
                    <textarea
                      className="form-control bg-light text-uppercase"
                      id="criminalDetails"
                      rows="4"
                      placeholder="ENTER FIR NUMBER, POLICE STATION NAME, SECTIONS, AND CURRENT STATUS OF THE CASE..."
                      value={criminalDetails}
                      onChange={(e) => setCriminalDetails(e.target.value)}
                      maxLength="1000"
                      required
                    />
                    <div className="form-text text-muted mt-1">
                      Please provide comprehensive details. Maximum 1000 characters.
                    </div>
                  </div>
                </div>
              )}

              {/* --- SECTION: REQUIRED DOCUMENT UPLOADS --- */}
              <h4 className="fw-bold text-uppercase mb-4 mt-5 border-top pt-4" style={{ color: '#06213f' }}>Required Document Uploads</h4>

              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">21. Update Proof of Date of Birth (Matriculation) <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                  <input type="file" accept="application/pdf" className="form-control bg-light mb-2" onChange={handledobfilechange} />
                  {dobURL && <a href={dobURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">22. Update Domicile Certificate of UT Ladakh <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                  <input type="file" accept="application/pdf" className="form-control bg-light mb-2" onChange={handledomfilechange} />
                  {domURL && <a href={domURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">23. Update Certificate for Essential Educational Qualification ({qualification}) <span className="text-muted fw-normal d-block small">(Max 512kb; pdf only)</span></label>
                  <input type="file" accept="application/pdf" className="form-control bg-light mb-2" onChange={handleeducationFileChange} />
                  {eduURL && <a href={eduURL} target="_blank" rel="noreferrer" className="text-decoration-none small fw-bold">🔗 Preview Current Upload</a>}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">24. Update Image of Signature <span className="text-muted fw-normal d-block small">(Max 512kb; jpg/jpeg only)</span></label>

                  {/* Show the preview if either a local file is chosen OR a URL exists */}
                  {(signature || signatureURL) && (
                    <div className="mb-2 bg-white p-2 border rounded" style={{ display: 'inline-block' }}>
                      <img
                        alt="Signature Preview"
                        src={signature || signatureURL}
                        style={{ maxHeight: '60px', maxWidth: '200px', objectFit: 'contain' }}
                      />
                    </div>
                  )}

                  <input type="file" accept="image/jpeg" className="form-control bg-light" onChange={handlesignaturefilechange} />
                </div>
              </div>

              {/* Form Actions */}
              <div className="d-flex justify-content-end gap-3 mt-4 border-top pt-4">
                <Button onClick={handleExit} variant="outline-danger" size="lg" className="px-4">Go Back</Button>
                <button type="submit" className="btn btn-lg px-5 text-white" style={{ backgroundColor: '#06213f' }}>Save Changes</button>
              </div>

            </form>
          </Card.Body>
        </Card>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Profile;
